import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import styles from './App.module.scss';
import { LanguageProvider } from './contexts/LanguageContext';
import { CancelPage, InvalidStateErrorPage, NotInAppErrorPage, SuccessPage } from './components/Page';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';

function App() {
  const contextWrapper = (children: JSX.Element) => {
    return (
      <div className={styles.app}>
        <LanguageProvider>
          <FluentProvider theme={webLightTheme}>
            {children}
          </FluentProvider>
        </LanguageProvider>
      </div>
    );
  };

  return (
    <Router>
      <Routes>
        <Route path="/auth/atlassian/success" element={contextWrapper(<SuccessPage />)} />
        <Route path="/auth/atlassian/cancel" element={contextWrapper(<CancelPage />)} />
        <Route path="/auth/atlassian/invalid-state-error" element={contextWrapper(<InvalidStateErrorPage />)} />
        <Route path="/auth/atlassian/not-in-app-error" element={contextWrapper(<NotInAppErrorPage />)} />
      </Routes>
    </Router>
  );
}

export default App;
